import React, { FunctionComponent } from 'react';
import Divider from './Divider';

interface IProps {}

const VerticallySpacedDivider: FunctionComponent<IProps> = () => (
  <div style={{ marginBottom: 15, marginTop: 15 }}>
    <Divider noMargin />
  </div>
);

export default VerticallySpacedDivider;
